import React from "react";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { faSparkles } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const useStyles = makeStyles(() => ({
  root: {
    textTransform: "none",
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  /* toolbar row — lines up with SecondaryButton / PrimaryButton (40px, 13px) */
  sizeSm: {
    minHeight: 38,
    padding: "6px 16px",
    borderRadius: 10,
    boxShadow: "0 8px 18px rgba(37, 99, 235, 0.22)",
  },
  sizeMd: {
    height: 40,
    padding: "0px 16px",
    fontSize: 13,
    lineHeight: "18px",
    fontWeight: 800,
    borderRadius: 8,
    boxShadow: "0 8px 18px rgba(37, 99, 235, 0.22)",
  },
  /* hero CTA inside a modal / composer */
  sizeLg: {
    minWidth: 210,
    minHeight: 48,
    borderRadius: 14,
    boxShadow: "0 14px 30px rgba(37, 99, 235, 0.22)",
  },
  icon: {
    marginRight: 8,
    fontSize: 14,
  },
  iconSm: {
    marginRight: 6,
    fontSize: 12,
  },
  spinner: {
    marginRight: 8,
    color: "#fff",
  },
}));

const SIZE_CLASS = {
  sm: "sizeSm",
  md: "sizeMd",
  lg: "sizeLg",
};

/**
 * The single "do it with AI" button — sparkles icon, blue contained fill and
 * an inline spinner while the request is in flight.
 *
 * Sizes: sm (compact, inline with a field), md (listing header toolbar),
 * lg (hero CTA in a modal — the feed / kudos composer).
 */
const AIButton = React.forwardRef(
  (
    {
      children,
      size = "lg",
      loading = false,
      loadingLabel = "Creating with AI...",
      disabled,
      className,
      ...rest
    },
    ref,
  ) => {
    const classes = useStyles();
    const iconClass = size === "sm" ? classes.iconSm : classes.icon;
    const rootClass = [
      classes.root,
      classes[SIZE_CLASS[size] || SIZE_CLASS.lg],
      className,
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <Button
        ref={ref}
        variant="contained"
        color="primary"
        disabled={disabled || loading}
        className={rootClass}
        {...rest}
      >
        <FontAwesomeIcon icon={faSparkles} className={iconClass} />
        {loading && <CircularProgress size={16} className={classes.spinner} />}
        {loading ? loadingLabel : children}
      </Button>
    );
  },
);

export default React.memo(AIButton);
